import React from "react";
import { TodoPriority } from "../WorkspaceTodos/WorkspaceTodoEdit/WorkspaceTodoEditMain/__generated__/WorkspaceTodoEditMainPrioritySelector_Todo.graphql";
import * as Select from "@radix-ui/react-select";
import { AHText, Box, TodoPrioIcon } from "arkh";

import { PRIORITIES } from "widgets/src/Todo/TodoPriorities";
import { OrgSelector } from "../OrgSelector/Selector";

export function PrioritySelector(props: {
  selectedPriority: TodoPriority;
  onValueChange: (v: TodoPriority) => void;
  disabled?: boolean;
}) {
  const selectedPriority = PRIORITIES.find(
    (v) => v.value === props.selectedPriority
  );

  return (
    <OrgSelector
      disabled={props.disabled}
      options={PRIORITIES.map((p) => p.value)}
      selectedValue={props.selectedPriority}
      onValueChange={(v) => {
        if (!props.disabled) {
          props.onValueChange(v as TodoPriority);
        }
      }}
      renderValue={(v) => (
        <Box
          style={{
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",

            flex: 1,
          }}
        >
          <AHText
            spaceRight="small"
            style={{ flex: 1 }}
            color={
              selectedPriority?.isDefault ? "text-secondary" : "text-primary"
            }
          >
            {selectedPriority?.label}
          </AHText>

          <TodoPrioIcon priority={props.selectedPriority} />
        </Box>
      )}
      renderOption={(v) => {
        const p = PRIORITIES.find((p) => p.value === v);
        if (!p) {
          return null;
        }
        return (
          <Box style={{ flex: 1 }}>
            <Box
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                flex: 1,
              }}
            >
              <Select.ItemText>
                <AHText color="darkerText" spaceRight="large">
                  {p.label}
                </AHText>
              </Select.ItemText>
              <TodoPrioIcon priority={p.value} />
            </Box>
            <AHText
              type="detail"
              style={{ maxWidth: 200 }}
              color="darkText"
              spaceRight="large"
            >
              {p.description}
            </AHText>
          </Box>
        );
      }}
    />
  );
}
